export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Germany-f9f516c9d08de70a77e92e8e0afe292d.mp3";